import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UtilsService } from 'src/app/services/utils.service';
import { MaintenanceService } from 'src/app/services/maintenance.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PriorityService } from 'src/app/services/priority.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-add-item',
    templateUrl: './add-item.component.html',
    styleUrls: ['./add-item.component.css']
})
export class AddItemComponent {

    unit: any = {}
    dataUser: any = {}
    priority: any[] = []
    now: Date = new Date()
    text_loading = "Espere un momento..."

    form!: FormGroup
    submitting = false

    constructor(
        private location: Location,
        private utils: UtilsService,
        private apiMaintenance: MaintenanceService,
        private spinner: NgxSpinnerService,
        private apiPriority: PriorityService,
        private fb: FormBuilder,
        private router: Router
    ) { }

    private pad2(n: number) { return n < 10 ? `0${n}` : `${n}` }
    private formatDate(d: Date) { return `${d.getFullYear()}-${this.pad2(d.getMonth() + 1)}-${this.pad2(d.getDate())}` }
    private formatTime(d: Date) { return `${this.pad2(d.getHours())}:${this.pad2(d.getMinutes())}` }

    ngOnInit(): void {
        this.spinner.show()
        const unit: any = this.location.getState()
        this.dataUser = this.utils.getDataUser()
        this.unit = unit.data

        this.form = this.fb.group({
            request_date: [this.formatDate(this.now)],
            request_hour: [this.formatTime(this.now)],
            user_id: [this.dataUser?.id || ''],
            unit_id: [this.unit?.id || ''],
            priority_id: ['', Validators.required],
        })

        this.apiPriority.getData().subscribe({
            next: (resp: any) => {
                this.priority = (resp as any[]) || []
            },
            complete: () => this.spinner.hide()
        })
    }

    onSubmit() {
        if (this.form.invalid) { this.form.markAllAsTouched(); return }

        this.submitting = true
        this.spinner.show()
        this.apiMaintenance.addMaintenanceCoordinator(this.form.getRawValue()).subscribe({
            next: () => {},
            error: (err: any) => {
                this.spinner.hide()
                this.submitting = false
                Swal.fire({ icon: 'error', title: 'Error', text: 'Se ha presentado un error al crear la solicitud de mantenimiento' })
            },
            complete: () => {
                this.submitting = false
                this.spinner.hide()
                Swal.fire({ icon: 'success', title: 'Exitoso', text: 'Se ha creado la solicitud de mantenimiento de forma exitosa' }).then(() => {
                    this.location.back()
                })
            }
        })
    }

    onCancel() {
        this.location.back()
    }
}
